import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { CITIES, SERVICES, EXTRA_SERVICES } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 outline-none transition-all duration-200 focus:border-sky-500 focus:ring-4 focus:ring-sky-100";

export const MeasurementForm = ({ prefill }) => {
  const [form, setForm] = useState({ name: "", phone: "", city: "", service: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (prefill) {
      setForm((f) => ({
        ...f,
        service: prefill.service || f.service,
        message: prefill.message || f.message,
      }));
    }
  }, [prefill]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.city) {
      toast.error("Užpildykite vardą, telefoną ir miestą.");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/leads`, form);
      toast.success("Ačiū! Registracija gauta. Susisieksime per 15 minučių sutarti dėl laiko.");
      setForm({ name: "", phone: "", city: "", service: "", email: "", message: "" });
    } catch (err) {
      toast.error("Nepavyko išsiųsti. Pabandykite dar kartą arba skambinkite mums.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="hero-registration-form" className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div>
        <label className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-500">Vardas *</label>
        <input
          data-testid="form-name-input"
          className={inputCls}
          placeholder="Jūsų vardas"
          value={form.name}
          onChange={set("name")}
        />
      </div>
      <div>
        <label className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-500">Telefonas *</label>
        <input
          data-testid="form-phone-input"
          className={inputCls}
          placeholder="+370 6XX XXXXX"
          value={form.phone}
          onChange={set("phone")}
        />
      </div>
      <div>
        <label className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-500">Miestas *</label>
        <select data-testid="form-city-select" className={inputCls} value={form.city} onChange={set("city")}>
          <option value="">Pasirinkite miestą</option>
          {CITIES.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-500">Lubų tipas</label>
        <select data-testid="form-service-select" className={inputCls} value={form.service} onChange={set("service")}>
          <option value="">Dar nežinau / konsultacija</option>
          {SERVICES.map((s) => (
            <option key={s.id} value={s.title}>
              {s.title}
            </option>
          ))}
          {EXTRA_SERVICES.map((s) => (
            <option key={s.id} value={s.title}>
              {s.title}
            </option>
          ))}
        </select>
      </div>
      <div className="sm:col-span-2">
        <label className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-500">
          El. paštas (neprivaloma — atsiųsime patvirtinimą)
        </label>
        <input
          data-testid="form-email-input"
          type="email"
          className={inputCls}
          placeholder="vardas@pastas.lt"
          value={form.email}
          onChange={set("email")}
        />
      </div>
      <div className="sm:col-span-2">
        <label className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-slate-500">
          Žinutė / apytikris plotas m²
        </label>
        <textarea
          data-testid="form-message-input"
          className={`${inputCls} min-h-[96px] resize-none`}
          placeholder="Pvz.: svetainė ~25 m², norėtume LED linijų..."
          value={form.message}
          onChange={set("message")}
        />
      </div>
      <button
        type="submit"
        disabled={sending}
        data-testid="form-submit-button"
        className="group mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-navy-900 px-8 py-4 text-sm font-semibold text-white transition-all duration-300 hover:bg-navy-800 hover:shadow-[0_16px_40px_-12px_rgba(10,25,47,0.5)] disabled:opacity-60 sm:col-span-2"
      >
        {sending ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Send className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5" />
        )}
        Registruotis nemokamam matavimui
      </button>
    </form>
  );
};
